import { Line } from 'vue-chartjs'

export default {
  name: 'line-chart',
  mixins: [Line]
}
